import React from 'react';
import GetQuotesButton from './GetQuotesButton';

/* Load adviser banner images for all sizes */
require('../../../images/adviser_banner_xsmall.jpg');
require('../../../images/adviser_banner_small.jpg');
require('../../../images/adviser_banner_tablet.jpg');
require('../../../images/adviser_banner_medium.jpg');
require('../../../images/adviser_banner_large.jpg');

const AdviserInfo = props => {
    return (
        <div className="app__landing-page__section--full">
            <div className="app__landing-page__full-image adviser-banner__image">
                <div className="app__landing-page__adviser-info--left">
                    <div className="adviser-banner__header">
                        <span className="line">
                            "My adviser has helped me put a plan in place - I feel a lot more
                            confident and secure about the future."
                        </span>
                    </div>
                    <div className="adviser-banner__subtitle">
                        The financial advisers we suggest for you will be local to you, verified
                        experts, and positively reviewed by their clients
                    </div>
                    <GetQuotesButton handler={props.scrollToForm} />
                </div>
            </div>
        </div>
    );
};

export default AdviserInfo;
